const buildShortbreadUrl = (path: string) => {
  const queryStrippedPath = path.split('?')[0]
  return `${window.location.protocol}//${window.location.host}${queryStrippedPath}`
}

export { buildShortbreadUrl }
